import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { PageEvent } from '@angular/material/paginator';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { MailstatusService } from 'src/app/shared/services/adminpanel/mailstatus.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';



export interface Email {

}

@Component({
  selector: 'app-view-template',
  templateUrl: './view-template.component.html',
  styleUrls: ['./view-template.component.scss']
})

export class ViewTemplateComponent implements OnInit {
  [x: string]: any;
  htmlContent = `<p style="text-align:center;"><img class="image_resized" style="width:130px;" src="https://mcusercontent.com/7b04161b831eafb922e1c9220/images/2ba460c5-63d3-4d91-93cb-e4472225d9a6.png" alt="logo"></p><p style="text-align:center;"><a href="http://webmail.novuscode.com/cpsess7915627313/3rdparty/roundcube/?_task=mail&amp;_caps=pdf%3D1%2Cflash%3D0%2Ctiff%3D0%2Cwebp%3D1&amp;_uid=829&amp;_mbox=INBOX.Trash&amp;_safe=1&amp;_action=show#v1"><img class="image_resized" style="width:598px;" src="https://mcusercontent.com/7b04161b831eafb922e1c9220/images/950bc10c-94e7-fac0-ae7d-af8698321db2.png" alt="Testsigma Community Edition"></a></p><p style="margin-left:0px;">&nbsp;</p><p style="margin-left:0px;">Hi NA,</p><p style="margin-left:0px;">It's finally here!</p><p style="margin-left:0px;">We're thrilled and proud to announce <strong>Testsigma Community Edition (CE)</strong>, a completely open-source test automation platform.</p><p style="margin-left:0px;">The open-source edition lets you set up instantly and start automating tests in just minutes! 🤩</p><p style="margin-left:0px;">We think you'll like these features:</p><ul><li><strong>Test Recorder:</strong> Record user actions, converted into an editable test script in real-time! The test steps are in simple English statements that anyone can understand. Learn more in our recorder tutorial <a href="https://testsigma.us17.list-manage.com/track/click?u=7b04161b831eafb922e1c9220&amp;id=b9bbe2bbe0&amp;e=dbc56da213">here</a>.</li><li><strong>English scripts:</strong> Write test steps in no time using simple English statements and enable everyone in your team to contribute and speed up test creation.</li><li><strong>Add-ons:</strong> We've simplified extending test scenarios with addons for 100+ automation actions and data generators accessed instantly. Check out the complete list <a href="https://testsigma.us17.list-manage.com/track/click?u=7b04161b831eafb922e1c9220&amp;id=a2258d50f4&amp;e=dbc56da213">here</a>. Can't find what you need? <a href="https://testsigma.us17.list-manage.com/track/click?u=7b04161b831eafb922e1c9220&amp;id=1a7bfaff99&amp;e=dbc56da213">Here's</a> our comprehensive guide to building your own!</li><li><strong>Visual Testing:</strong> By connecting your local Testsigma repository to the cloud you can compare 1000s of screens and ensure you deliver pixel-perfect UI to users. Check out all the <a href="https://testsigma.us17.list-manage.com/track/click?u=7b04161b831eafb922e1c9220&amp;id=22629d9084&amp;e=dbc56da213">cloud features</a> you can access here.</li></ul><p style="margin-left:0px;">Additionally, you can shape the project with your contributions and weave your way into a community of test automation enthusiasts just like yourself.</p><div class="raw-html-embed"><p style="margin-top: 10px; line-height: 29px; margin-left: 0px; color: #000000; font-family: Roboto, sans-serif; font-size: 16px; font-weight: 300; padding-bottom: 17px; padding-left: 30px; background-color: #fff; padding-right: 40px; letter-spacing: -.39px; margin-bottom: 0px">
 <a href="https://testsigma.us17.list-manage.com/track/click?u=7b04161b831eafb922e1c9220&amp;id=6a2a2bed58&amp;e=dbc56da213" style="color: #FFF; background: #03A973 !important; border: 1px solid #03A973 !important; padding: 15px 15px; border-radius: 7px; width: 100%; min-width: 50px; max-width: 150px; margin: 20px auto; display: block; text-decoration: none" class="v1btn_leep" target="_blank" rel="noreferrer"><span style="font-family: 'Mulish', sans-serif; font-size: 15px; font-weight: 500; text-align: center; margin-left: 2px; margin: auto; display: flex"><span style="padding-left: 1em">View in GitHub!</span> <img style="padding-left: 0.5em" src="https://mcusercontent.com/7b04161b831eafb922e1c9220/images/e2ff7fa5-4dfe-591c-b459-7380556f165f.png"></span></a>
 </p></div><p style="margin-left:0px;">To get the complete low-down on Testsigma CE, check out our newly revamped <a href="https://testsigma.us17.list-manage.com/track/click?u=7b04161b831eafb922e1c9220&amp;id=fef66b06e5&amp;e=dbc56da213">documentation</a>.</p><p style="margin-left:0px;">Cheers!</p><p style="margin-left:0px;">With 💚<br>Testsigma Community</p><p style="margin-left:auto;text-align:center;"><i>Connect with some of the most inventive test automation enthusiasts from across the world. </i><a href="https://testsigma.us17.list-manage.com/track/click?u=7b04161b831eafb922e1c9220&amp;id=3aef35d435&amp;e=dbc56da213"><i><strong>Join us!</strong></i></a></p>`
  Content: any;

  visible = true;
  selectable = true;
  removable = true;
  removable2 = true;
  removable3 = true;
  removable4 = true;
  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  selectable2 = true;
  addOnBlur2 = true;
  readonly separatorKeysCodes2 = [ENTER, COMMA] as const;
  selectable3 = true;
  addOnBlur3 = true;
  readonly separatorKeysCodes3 = [ENTER, COMMA] as const;
  selectable4 = true;
  addOnBlur4 = true;
  readonly separatorKeysCodes4 = [ENTER, COMMA] as const;
  emailfrom: any = ['no-reply@smokycrm.com'];
  emailto: any;
  emailcc: any;
  emailbcc: any;
  isLoading: boolean;
  mailstatus: any;
  dataSource: any;
  paginator: any;
  currentPage: any;
  emailDraftId: any;
  ViewEmailData: any;
  uploadattachment: any;
  uploadFileName: any;
  attachmentGetdocx: any;
  attachmentGetpdf: any;
  attachmentGetxlsx: any;

  /* from */
  addfrom(event: MatChipInputEvent): void {
    // const value = (event.value || '').trim();
    const inputfrom = event.input;
    const valuefrom = event.value;
    //add email
    if ((valuefrom || '').trim()) {
      this.emailfrom.push(valuefrom.trim());
    }

    //reset email
    if (inputfrom) {
      inputfrom.value = '';
    }
  }

  removefrom(from: any): void {
    const index = this.emailfrom.indexOf(from);

    if (index >= 0) {
      this.emailfrom.splice(index, 1);
    }
  }

  /* To */
  addto(event: MatChipInputEvent): void {
    // const value = (event.value || '').trim();
    const inputto = event.input;
    const valueto = event.value;
    //add email
    if ((valueto || '').trim()) {
      this.emailto.push(valueto.trim());
    }

    //reset email
    if (inputto) {
      inputto.value = '';
    }
  }

  removeto(to: any): void {
    const index = this.emailto.indexOf(to);

    if (index >= 0) {
      this.emailto.splice(index, 1);
    }
  }

  /* cc */
  addcc(event: MatChipInputEvent): void {
    // const value = (event.value || '').trim();
    const inputcc = event.input;
    const valuecc = event.value;

    //add email
    if ((valuecc || '').trim()) {
      this.emailcc.push(valuecc.trim());
    }

    //reset email
    if (inputcc) {
      inputcc.value = '';
    }
  }

  removecc(cc: any): void {
    const index = this.emailcc.indexOf(cc);
    console.log(index)
    if (index >= 0) {
      this.emailcc.splice(index, 1);
    }
  }

  /* bcc */
  addbcc(event: MatChipInputEvent): void {
    //const value = (event.value || '').trim();
    const inputbcc = event.input;
    const valuebcc = event.value;

    //add email
    if ((valuebcc || '').trim()) {
      this.emailbcc.push(valuebcc.trim());
    }

    //reset email
    if (inputbcc) {
      inputbcc.value = '';
    }
  }

  removebcc(bcc: any): void {
    const index = this.emailbcc.indexOf(bcc);

    if (index >= 0) {
      this.emailbcc.splice(index, 1);
    }
  }


  constructor(private _sanitizer: DomSanitizer,
    private MailstatusService: MailstatusService,
    private formBuilder: FormBuilder,
    
    private matSnack: SnackbarService,
    private router: Router
  ) { }


  ngOnInit(): void {
    
    this.emailDraftId = localStorage.getItem('emailDraftId')

    this.subjectodmail = this.formBuilder.group({
      subject: new FormControl(''),
    })
    this.ViewEmail()
  }

  get f() { return this.subjectodmail.controls; }
  ViewEmail() {
    //this.dataSource.filter = filterValue.trim().toLowerCase();
    this.MailstatusService.getEmaildatabyid<any>(`api/EmailDraft/ViewEmailDraft?id=${this.emailDraftId}`)
      .subscribe((data: any) => {
        console.log(data)
        // this.ViewEmailData = data.data.emailDraft
        this.ViewEmailData = data
        this.body = data.body
        this.Content = this._sanitizer.bypassSecurityTrustHtml(data.body)
        this.subject = data.subject
        this.emailto = data.to.split(';')
        this.emailcc = data.cc.split(';')
        this.emailbcc = data.bcc.split(';')
        this.attachment = data.attachment;
        this.attachmenttype = data.type
        if(this.attachmenttype === "docx" || this.attachmenttype === ".docx"){
          this.attachmentGetdocx = 'data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,' + data.attachment
        }
        
        if(this.attachmenttype === "pdf" || this.attachmenttype === ".pdf"){
          this.attachmentGetpdf = 'data:application/pdf;base64,' + data.attachment
        }
        
        if(this.attachmenttype === "xlsx" || this.attachmenttype === ".xlsx"){
          this.attachmentGetxlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + data.attachment
        }
       
        console.log(data.attachment, data.type)
      });
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    // this.applyFilter($event);
  }

  getviewemaildraft() {
    {
      this.isLoading = true;
      this.MailstatusService.getviewemaildraft()
        .subscribe((data: any) => {
          this.isLoading = false;
          this.mailstatus = data;
          this.dataSource = data.data
          console.log(data)
        });
    }
  }
  fileChangeEvent(event) {
    // console.log(event)
    const file = event.target.files[0];
    console.log(file)
    this.uploadFileName = file.name
    this.uploadattachmentType = file.name.split('.')[1]
    console.log(file.name.split('.'))
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      // console.log(reader.result);
      var uploadattachment = reader.result
      this.uploadattachment = (<string>reader.result).split('base64,')[1]
      console.log(uploadattachment)
    };
  }
  viewTemplate(image) {
    console.log(image)
    localStorage.setItem('emailDraftId', image.id)
  }


  joinsymptomps(arrayValue) {
    var StringValue = arrayValue
    return Array.prototype.map.call(StringValue, function (item) {
      return item;
    }).join(";");
  }
  send() {
    var attachment = this.uploadattachment == null ? this.attachment : this.uploadattachment
    var attachmenttype = this.uploadattachmentType == null ? this.attachmenttype : this.uploadattachmentType
    var formData = new FormData();
    formData.append("From", this.emailfrom);
    formData.append("To", this.joinsymptomps(this.emailto));
    formData.append("subject", this.f.subject.value);
    formData.append("message", this.body);
    formData.append("cc", this.joinsymptomps(this.emailcc));
    formData.append("bcc", this.joinsymptomps(this.emailbcc));
    formData.append("Attachment", attachment);
    formData.append("type", attachmenttype);
    formData.append("DraftId", this.emailDraftId);
    this.MailstatusService.sendEmail(`api/EmailDraft/SendEmail`, formData)
      .pipe(first())
      .subscribe(
        data => {
          console.log(formData)
          console.log(data)
          this.matSnack.showNotification("Mail Send", "")
          this.router.navigateByUrl('/admin/email/emailstatus')
        },
        error => {
        }
      );
  }
  downloadDocument(item: string) {
    // console.log(item)
    // FileSaver.saveAs(item);
    window.open(item, '_blank');
  }
}
